/**
 * @Author: Zero
 * @Date: 2024-11-18 10:58:44
 * @Explain: 周期活动
 */
import http from '../http';

const MODEL = '/task';

export default {
  // 获取活动列表 - （进行中、暂停、已完成）
  getCampaignsList(data: Record<any, any>) {
    return http.post(`${MODEL}/get_campaigns`, data);
  },
  // 获取列表
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/get-list`, data);
  },
  // 获取当前活动 - 国家列表
  getCountryData(data: Record<any, any>) {
    return http.post(`${MODEL}/task_country_data`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 添加
  onAdd(data: Record<any, any>) {
    return http.post(`${MODEL}/create-campaign`, data);
  },
  // 编辑
  onEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/update-campaign`, data);
  },
  // 保存草稿
  onSaveDraft(data: Record<any, any>) {
    return http.post(`${MODEL}/save-draft`, data);
  },
  // 更新活动类型
  updateActivityType(data: Record<any, any>) {
    return http.post(`${MODEL}/update-campaign-type`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取活动类型配置
  getActivityTypeConfig(data: Record<any, any>) {
    return http.post(`${MODEL}/get-campaign-type`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 验证标题是否重复
  checkName(data: Record<any, any>) {
    return http.post(`${MODEL}/check-campaign-title-existing`, data);
  },
  // 获取详情
  getDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/get-campaign-detail`, data);
  },
  // 获取周期修改记录
  getCycleModifyRecord(data: Record<any, any>) {
    return http.post(`${MODEL}/get_timelines`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取周期详情
  getCycleDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/get_periods`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取上次提交活动的详情
  getLastDetails() {
    return http.post(`${MODEL}/get-latest-campaign-info`);
  },
  // 验证邮件模板
  checkTemplate(data: Record<any, any>) {
    return http.post(`${MODEL}/check-template`, data);
  },
  // 获取审批人列表
  getApproverList(data: Record<any, any>) {
    return http.post(`${MODEL}/get-check-users`, data);
  },
  // 审批
  onApproval(data: Record<any, any>) {
    return http.post(`${MODEL}/check-activity`, data);
  },
  // 审批 - 催办
  onApprovalUrge(data: Record<any, any>) {
    return http.post(`${MODEL}/reminder-check-user`, data);
  },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/delete`, data);
  },
  // 撤销
  onRevoke(data: Record<any, any>) {
    return http.post(`${MODEL}/cancel-check`, data);
  },
  // 开始活动
  onStart(data: Record<any, any>) {
    return http.post(`${MODEL}/required`, data);
  },
  // 暂停活动
  onSuspend(data: Record<any, any>) {
    return http.post(`${MODEL}/suspend`, data);
  },
  // 终止活动
  onTermination(data: Record<any, any>) {
    return http.post(`${MODEL}/stop`, data);
  },
  // 发送测试邮件
  onSendTestMail(data: Record<any, any>) {
    return http.post(`${MODEL}/test-campaign`, data);
  },

  // 周期活动列表 - 查询周期活动错过执行的周期及是否允许补发标识
  getMissingPeriods(data: Record<any, any>) {
    return http.post(`${MODEL}/get_missing_periods`, data);
  },
  // 撤销 - 已计划列表操作项
  onRevokeScheduled(data: Record<any, any>) {
    return http.post(`${MODEL}/revoke`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
